import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClickService} from '../../../core/services/click.service';
import {EscapeKeyService} from '../../../core/services/escape-key.service';
import {BaseDrawerComponent} from '../_base-drawer/base-drawer.component';
import {NgStyle} from '@angular/common';
import {TileHistoryViewportBufferComponent} from '../tile-history-viewport-buffer/tile-history-viewport-buffer.component';

@Component({
  selector: 'motn-drawer-height-from-bottom',
  templateUrl: './drawer-height-from-bottom.component.html',
  styleUrls: ['./drawer-height-from-bottom.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgStyle,
    TileHistoryViewportBufferComponent,
  ],
})
export class DrawerHeightFromBottomComponent extends BaseDrawerComponent implements OnInit, OnDestroy {
  @Input() addToBottomHeight: number = 0;

  /**
   * When true, the drawer anchors to the bottom of the viewport and grows
   * upward to fit its content (capped at the viewport height) instead of
   * opening to a fixed height. Use this when the whole drawer should be
   * visible without scrolling.
   */
  @Input() fitContent: boolean = false;

  cssMinHeight: string;
  cssMarginTop: string;


  constructor(
    protected clickService: ClickService,
    protected escapeKeyService: EscapeKeyService,
  ) {
    super(clickService, escapeKeyService);
  }


  protected onInit() {
    if (this.fitContent) {
      // Positioning is handled entirely by the `.fit-content` CSS class.
      return;
    }

    const heightFromBottomPx = +this.bodyStyle.getPropertyValue('--motn-drawer-height-bottom').replace('px', '');

    this.cssMinHeight = (heightFromBottomPx + this.addToBottomHeight) + 'px';
    this.cssMarginTop = `calc(100vh - ${this.cssMinHeight})`;
  }
}
